import QRCode from 'qrcode.react'
import React from 'react'

export const QRcodeGlobal = props => {
  return (
    <QRCode
      level={props.level}
      value={props.value}
      renderAs={props.renderAs}
      size={props.size}
      bgColor={props.bgColor}
      fgColor={props.fgColor}
      includeMargin={props.marginSize}
      imageSettings={props.imageSettings}
      style={props.style}
    />
  )
}
